import React from 'react';
import { Layout } from 'components';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { routes } from 'utils';
import Login from 'pages/Login';
import { RouteType } from 'utils/routes';
import { AuthProvider } from 'context/AuthContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient();


const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
        <AuthProvider>
            <React.Suspense fallback={<div>Loading...</div>}>
                <BrowserRouter>
                    <Routes>
                        {/* Public Route: Login */}
                        <Route path="/login" element={<LoginLayout />}>
                            <Route index element={<Login />} />
                        </Route>

                        {/* Protected Routes */}
                        <Route element={<MainLayout />}>
                            {routes
                                .filter((route: RouteType) => route.path !== '/login')
                                .map((route: RouteType) => (
                                    <Route
                                        key={route.path}
                                        path={route.path}
                                        element={route.element}
                                    />
                                ))}
                        </Route>
                    </Routes>
                </BrowserRouter>
            </React.Suspense>
        </AuthProvider>
        </QueryClientProvider>
    );
};

export default App;

// Layout for protected routes
const MainLayout = () => {
    return (
        <Layout>
            <Outlet />
        </Layout>
    );
};

// Layout for login page
const LoginLayout = () => {
    return (
        <div>
            <Outlet />
        </div>
    );
};